"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("modules/content/constants");
const uuid_1 = require("uuid");
class DrippingFormUtil {
    static isNumberOfDaysValid(value) {
        return value > constants_1.MIN_LIBERATION_DAYS && value <= constants_1.MAX_LIBERATION_DAYS;
    }
    static generateKey() {
        return (0, uuid_1.v4)();
    }
}
exports.default = DrippingFormUtil;
